
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/healthcare",
      function () {
        return require("private-next-pages/use-cases/healthcare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/healthcare"])
      });
    }
  